import React from 'react';
import axios from 'axios';
import { useState } from 'react';
import Swal from 'sweetalert2';

const Contact = () => {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [subject, setSubject] = useState('');
    const [message, setMessage] = useState('');
    const handleSubmit = (e) => {
        e.preventDefault();
        try{
            axios.post('https://stage-cni-backend.vercel.app/sendMessage', {
                name,
                email,
                subject,
                message,
            })
            Swal.fire({
                icon: 'success',
                title: 'Message sended Successfully!',
                text: 'We have successfully sent your message.',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Great!',
              });
        }     
         catch (err) {
          console.error(err.message);
        }
    };
    return (
        <div className="container-xxl py-5">
            <div className="container">
                <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
                    <h6 className="section-title bg-white text-center text-primary px-3">Contact Us</h6>
                    <h1 className="mb-5">Contact For Any Query</h1>
                </div>
                <div className="row g-4">
                    <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
                        <h5>Get In Touch</h5>
                        <p className="mb-4">For any inquiries, collaborations, or simply to get in touch, feel free to reach out to us.</p>
                        <div className="d-flex align-items-center mb-3">
                            <div className="d-flex align-items-center justify-content-center flex-shrink-0 bg-primary" style={{ width: "50px", height: "50px" }}>
                                <i className="fa fa-map-marker-alt text-white"></i>
                            </div>
                            <div className="ms-3">
                                <h5 className="text-primary">Location</h5>
                                <p className="mb-0">17, 1005 Av. Belhassen Ben Chaabane, Tunis</p>
                            </div>
                        </div>
                        <div className="d-flex align-items-center mb-3">
                            <div className="d-flex align-items-center justify-content-center flex-shrink-0 bg-primary" style={{ width: "50px", height: "50px" }}>
                                <i className="fa fa-phone-alt text-white"></i>
                            </div>
                            <div className="ms-3">
                                <h5 className="text-primary">Mobile</h5>
                                <p className="mb-0">+216 71 78 30 55</p>
                            </div>
                        </div>
                        <div className="d-flex align-items-center">
                            <div className="d-flex align-items-center justify-content-center flex-shrink-0 bg-primary" style={{ width: "50px", height: "50px" }}>
                                <i className="fa fa-envelope-open text-white"></i>
                            </div>
                            <div className="ms-3">
                                <h5 className="text-primary">Email</h5>
                                <p className="mb-0">webcni@cni.tn</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.3s">
                        <iframe className="position-relative rounded w-100 h-100"
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3194.5306616072666!2d10.180793515241783!3d36.794745172537956!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12fd349cd86c36c5%3A0x65e0b28b27b42d38!2s17%2C%201005%20Av.%20Belhassen%20Ben%20Chaabane%2C%20Tunis!5e0!3m2!1sen!2stn!4v1603794290143!5m2!1sen!2stn"
                            frameBorder="0" style={{ minHeight: "300px", border: "0" }} allowFullScreen="" aria-hidden="false"
                            tabIndex="0"></iframe>
                    </div>


                    <div className="col-lg-4 col-md-12 wow fadeInUp" data-wow-delay="0.5s">
                        <form onSubmit={handleSubmit}>
                            <div className="row g-3">
                                <div className="col-md-6">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="name" placeholder="Your Name" onChange={(e) => setName(e.target.value)}/>
                                        <label htmlFor="name">Your Name</label>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-floating">
                                        <input type="email" className="form-control" id="email" placeholder="Your Email" onChange={(e) => setEmail(e.target.value)}/>
                                        <label htmlFor="email">Your Email</label>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="subject" placeholder="Subject" onChange={(e) => setSubject(e.target.value)}/>
                                        <label htmlFor="subject">Subject</label>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="form-floating">
                                        <textarea className="form-control" placeholder="Leave a message here" id="message" style={{ height: "150px" }} onChange={(e) => setMessage(e.target.value)}></textarea>
                                        <label htmlFor="message">Message</label>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <button className="btn btn-primary w-100 py-3" type="submit">Send Message</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Contact;
